<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'500px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">{{title}}</h3>
      <div class="">
        <el-form
          label-position="top"
          ref="form"
          :model="form"
        >
          <el-form-item>
            <el-input
              v-model="form.content"
              type="textarea"
              placeholder="Ghi chú"
              rows="5"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="ketThuc"
          :disabled="isProcessing"
        >
          <i :class="[!isProcessing ? 'fas fa-check-circle font-size__small' : 'el-icon-loading']"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import { EventBus } from '../../../event-bus.js';

export default {
  name: "DocOutKetThuc",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "objects", "title"],
  components: {
    dialogTemplate: () => import('../../common/custom-dialog.vue')
  },

  computed: {

    parentRoute () {
      return this.$route.path.split("/")[3];
    },
  },

  data () {
    return {
      isProcessing: false,
      form: { content: null },
    };
  },

  methods: {
    backModel () {
      this.$router.push({ name: this.parentRoute, params: this.$route.params });
      ;
    },

    ketThuc_ (index) {
      if (index == this.objects.length) {
        this.isProcessing = false;
        EventBus.$emit(this.parentRoute, {});
        this.$emit("success", {});
        // this.backModel();
        return;
      }

      let item = this.objects[index];

      // if (item.status == "success") this.ketThuc_(index + 1);

      var submitForm = {
        incomingProcessId: item.processId,
        content: this.form.content,
      };

      vbIncomingProcessService
        .ketThuc(submitForm, item.docId)
        .then((response) => {
          this.ketThuc_(index + 1);
          EventBus.$emit('loadCounting', '');
        })
        .catch(error => {
          this.isProcessing = true;
          this.commonHandleRequestError(error)
        });
    },

    ketThuc () {
      if (this.objects && this.objects.length) {
        this.isProcessing = true;
        this.ketThuc_(0);
      }

    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/DocOutKetThuc.vue